import { defineStore, getActivePinia } from 'pinia'

import { actions } from './actions'
import { getters } from './getters'
import { state } from './state'

export const mainStore = (gaApp) => {
  const init = defineStore('appMain', {
    actions: actions(gaApp),
    getters: getters(gaApp),
    state,
  })

  return init(getActivePinia())
}
